angular.module('logbook')
.directive('shiftSigninConfig', ['$timeout', "$http", "$location", "$window",
function($timeout, $http, $location, $window) {
  return {
    restrict: 'E',

    scope: {
       selectedLog: '='
    },

	template: require('./shift-signin-config.html'),

    link: function(scope, elem, attrs) {
       scope.refreshLog = function()
       {
          $http.get($location.search()['editLog']).then(function(result) {
             scope.log = result.data;
             var signInTag = scope.log._embedded.signInTag;
             var signOutTag = scope.log._embedded.signOutTag;
             scope.selectedTagValues['signInTag'] = signInTag ? [signInTag._links.self.href] : [];
             scope.selectedTagValues['signOutTag'] = signOutTag ? [signOutTag._links.self.href] : [];
             scope.selectedTagValueObjects['signInTag'] = signInTag ? [signInTag] : [];
             scope.selectedTagValueObjects['signOutTag'] = signOutTag ? [signOutTag] : [];
           });
       };
       scope.refreshLog();
       
       scope.selectedTagValues = {};
       scope.selectedTagValueObjects = {};
       scope.selectedTagValues['signInTag'] = [];
       scope.selectedTagValues['signOutTag'] = [];
       scope.selectedTagValueObjects['signInTag'] = [];
       scope.selectedTagValueObjects['signOutTag'] = [];
       
       scope.templateHelpText = '<div class="well">Specify a template for auto-generated messages here.  Example:<div>'
          + '{{shift.user.firstName}} {{shift.user.lastName}} is now on shift{{#if shift.role}} as {{shift.role.name}}{{/if}}{{#if formattedEndTime}}, until {{formattedEndTime}}{{/if}}.'
          + "</div></div>";
       
       scope.updateLogField = function(field, data)
       {
          var config = {
             'noErrorPopup': true,
             'noValue': true};
          
          var update = {};
          update[field] = data;
          return $http.patch(scope.log._links.self.href, update, config)
             .then(scope.refreshLog);
       };
       
       scope.doSignInTagEdit = function()
       {
          scope.editSignInTag = true;
       };

       scope.doneEditingSignInTag = function() {
          scope.editSignInTag = false;
       };
       
       scope.doSignOutTagEdit = function()
       {
          scope.editSignOutTag = true;
       };

       scope.doneEditingSignOutTag = function() {
          scope.editSignOutTag = false;
       };
       
       scope.showHelp = function(role, show)
       {
          if('signIn' == role )
             scope.showSignInHelp = show;
          else
             scope.showSignOutHelp = show;
       };
       
       scope.updateLogTag = function(tagRole)
       {
          var update = {};
          update[tagRole] = scope.selectedTagValues[tagRole].length ? scope.selectedTagValues[tagRole][0] : null;
          return $http.patch(scope.log._links.self.href, update).then(function() {
             if( 'signInTag' == tagRole )
                delete scope.editSignInTag;
             if( 'signOutTag' == tagRole )
                delete scope.editSignOutTag;
             scope.refreshLog();
          });
       }
       
       
     }
  }
}]);
